import de from './locales/de'
import en from './locales/en'
import ch from './locales/ch'
import fr from './locales/fr'
import it from './locales/it'
import nl from './locales/nl'

export default {
  install: async (app, options) => {
    options.i18n.global.mergeLocaleMessage('de', de)
    options.i18n.global.mergeLocaleMessage('ch', ch)
    options.i18n.global.mergeLocaleMessage('en', en)
    options.i18n.global.mergeLocaleMessage('fr', fr)
    options.i18n.global.mergeLocaleMessage('it', it)
    options.i18n.global.mergeLocaleMessage('nl', nl)
  },
}
